/**
 * The signed-in person's own account: their name and their password. PocketBase only lets a user
 * update their own record (`id = @request.auth.id`), and a password change needs the old one.
 */
import { pb } from "@/lib/platform/pocketbase";

export async function updateName(userId: string, name: string) {
  // Updating the signed-in record also updates the auth store, so the header follows at once.
  return pb.collection("users").update(userId, { name: name.trim() });
}

/**
 * Changes the password and signs in again with it. PocketBase invalidates every session of the
 * user on a password change - this one included - so without the second step the person would
 * find themselves logged out right after saving.
 */
export async function changePassword(
  user: { id: string; email: string },
  input: { oldPassword: string; password: string },
) {
  await pb.collection("users").update(user.id, {
    oldPassword: input.oldPassword,
    password: input.password,
    passwordConfirm: input.password,
  });
  await pb.collection("users").authWithPassword(user.email, input.password);
}

/** True when PocketBase refused the change because the current password was wrong. */
export function isWrongOldPassword(error: unknown): boolean {
  const data = (error as { response?: { data?: Record<string, unknown> } })?.response?.data;
  return Boolean(data && "oldPassword" in data);
}
